/* 内存数据状态 */
export default {
  userInfo: '',
  platformType: '',
  showSafeTips: true,
  platformInfo: null
}



// WEBPACK FOOTER //
// ./src/store/state.js